/**
 * This feature's routes, as constants.
 *
 * Two groups, mounted in different applications. The desk's queue and the
 * customer's own claims are separate paths rather than one screen with a
 * filter, because they are separate audiences: `/sav` in the back office is a
 * queue of everybody's claims, and `/sav` in the portal is "mine".
 *
 * Separate from `routes.tsx` so a screen can link to another without
 * importing the module that builds the route table.
 */

export const SUPPORT_PATHS = {
  tickets: "/sav",
  ticket: "/sav/$id",
} as const;

export const SUPPORT_PORTAL_PATHS = {
  tickets: "/sav",
  ticket: "/sav/$id",
} as const;
